import React, { useState, useEffect } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTheme } from "../../../themes/theming";
import { downloadActionItem, fetchDealerActionItemReport } from "../../../actions/dashboardAction";
import LoadingOverlay from 'react-loading-overlay';
import { Fa } from 'mdbreact';
import ClampLines from 'react-clamp-lines';
import moment from "moment";
import { AUTO_DEFAULT_FILTER } from "../../../AppConstant";
var I18n = require("react-redux-i18n").I18n;

const ActionItemReportNAS = (props) => {
    const { dispatch, dealerOperations } = props;
    const [selectedToDownload, setSelectedToDownload] = useState([]);
    //const [isLoading, setIsLoading] = useState(false);
    const [queryDto, setQueryDto] = useState({});
    const [hasFetched, setHasFetched] = useState(false);
    const [data, setData] = useState([]);

    const downloadPdf = () => {
        const updatedQueryDto = { ...queryDto, actionPlanIdList: selectedToDownload, selectedBrand: props.theme.name };
        props.dispatch(downloadActionItem(selectedToDownload, updatedQueryDto));
    };

    const statusFormatter = (cell, row) => {
        return (
            <div>
                <button
                    variant="contained"
                    style={{
                        backgroundColor:
                            row.status === "Open"
                                ? "#cf142b"
                                : row.status === "Closed"
                                    ? "#3CB043"
                                    : row.status === "Completed"
                                        ? "#3CB043"
                                        : "primary",
                        lineHeight: 1,
                        color: "white",
                        textAlign: "center",
                        fontSize: "0.675rem"
                    }}
                    disabled
                >
                    {I18n.t(row.status)}
                </button>
            </div>
        );
    };

    const dueDateFormatter = (cell, row) => {
        const dueDate = moment(row.dueDate, 'DD/MM/YYYY');
        const todayDate = moment();
        const color = row.status === "Open" && todayDate.isAfter(dueDate) ? "red" : "";
        return (
            <span style={{ color: color }}>
                {row.dueDate}
            </span>
        );
    };

    const buttonFormatter = (cell, row, rowIndex, formatExtraData) => {
        // Warning sign to highlight the Action items which are overdue.
        const dueDate = moment(row.dueDate, 'DD/MM/YYYY');
        const todayDate = moment();
        const warningIconClass =
            row.status === "Open" && todayDate.isAfter(dueDate)
                ? "controlledIcon1"
                : "hideIcon1";

        return (
            <div>
                <div className="btn-toolbar float-right">
                    <a className={warningIconClass}>
                        <div
                            title={I18n.t('tmeAdminMaster.dueDateExceed')}
                            className="warning-icon"
                        />
                    </a>
                </div>
            </div>
        );
    };

    const counterMeasureFormatter = (cell, row) => {
        return (
            <ClampLines
                text={cell}
                lines={2}
                ellipsis="..."
                buttons={false}
                className="custom-class"
            />
        );
    };

    const columns = [{
        dataField: 'counterMeasure',
        text: I18n.t('Table.counterMeasure'),
        formatter: counterMeasureFormatter,
        style: { width: "18%", textAlign: "left", wordWrap: "break-word" },
        headerStyle: { width: "18%", textAlign: "left", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        title: true,
        headerTitle: true
    }, {
        dataField: 'location',
        text: I18n.t('Table.location'),
        sort: true,
        style: { width: "15.5%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        headerStyle: { width: "15%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        title: true,
        headerTitle: true
    }, {
        dataField: 'toolBoxName',
        text: I18n.t('Table.toolbox'),
        sort: true,
        style: { width: "8%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        headerStyle: { width: "8%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        title: true,
        headerTitle: true
    }, {
        dataField: 'actionPlanDisplayId',
        text: I18n.t('Table.id'),
        style: { width: "6%" },
        headerStyle: { width: "6%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        headerTitle: true

    }, {
        dataField: 'status',
        formatter: statusFormatter,
        text: I18n.t('Table.status'),
        sort: true,
        style: { width: "8%" },
        headerStyle: { width: "8%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        headerTitle: true
    }, {
        dataField: 'startDate',
        text: I18n.t('Table.startDate'),
        sort: true,
        style: { width: "8%" },
        headerStyle: { width: "7.5%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        headerTitle: true
    }, {
        dataField: 'dueDate',
        text: I18n.t('Table.dueDate'),
        sort: true,
        style: { width: "8%" },
        formatter: dueDateFormatter,
        formatExtraData: props,
        headerStyle: { width: "8%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        headerTitle: true
    }, {
        dataField: 'assignee',
        text: I18n.t('Table.assignee'),
        style: { width: "9%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        sort: true,
        headerStyle: { width: "10%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        headerTitle: true,
        title: true,
    },
    {
        dataField: "",
        text: "",
        isDummyField: 'formatter',
        formatter: buttonFormatter,
        formatExtraData: props,
        style: { width: "10%" },
        headerStyle: { width: "10%" }
    }];

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            if (e.target.type === "checkbox" || e.target.cellIndex === 0) {
                e.target.checked = true;
                const index = selectedToDownload.indexOf(row.actionPlanId);
                if (index > -1) {
                    setSelectedToDownload(prev => prev.filter((_, i) => i !== index));
                } else {
                    setSelectedToDownload(prev => [...prev, row.actionPlanId]);
                }
            }
        }
    };

    const selectRow = {
        mode: 'checkbox',
        selected: selectedToDownload,
        onSelectAll: (isSelect, rows, e) => {
            let selectedRows = [];
            rows.forEach((row) => {
                selectedRows.push(row.actionPlanId);
            });
            if (isSelect && selectedRows.length > 0) {
                setSelectedToDownload(selectedRows);
                return selectedRows;
            }
            else {
                setSelectedToDownload([]);
            }
        }
    };

    /** Handler for API success callback */
    const onSuccess = (response) => setData(response);


    /** Handler for API failure callback */
    const onFailure = (error) => console.error("❌ Error while fetching list of video", error);


    const fetchProgressBarData = () => {
        try {
            if (!props.toolboxByType?.toolboxByType || props.toolboxByType.toolboxByType?.length === 0) {
                return;
            }

            const toolBoxList = props.toolboxByType?.toolboxByType;
            const cycleList = props.cycleDataList;

            if (!toolBoxList || toolBoxList?.length === 0 || !cycleList || cycleList?.length === 0) {
                console.warn("Required data is not ready yet.");
                return;
            }

            const initialToolBoxId = toolBoxList[toolBoxList?.length - 1];
            const initialCycle = cycleList[cycleList?.length - 1];

            if (!initialCycle?.cycle) {
                console.warn("Initial cycle format is missing.");
                return;
            }
            const [initialStartDate, initialEndDate] = initialCycle.cycle.split(" to ");
            const nmscCode = props.existingProps.userMdl.nmsc;
            const activeProgram = props.existingProps.userMdl.activeProgram;
            
            const data = {
                "userNmscCode": props.existingProps.userMdl.nmsc,
                "userLangCode": props.existingProps.userMdl.lang,
                "programList": [props.existingProps.userMdl.activeProgram],
                "nmscCode": props.existingProps.nmscFlag ? [nmscCode.toUpperCase()] : props.existingProps.nmscFilter,
                "brand": props.existingProps.brandFilter,
                "country": props.existingProps.countryFilter,
                "region": props.existingProps.regionFilter,
                "userId": props.existingProps.userMdl.username,
                "businessArea": props.existingProps.userMdl.businessAreaKey,
                "toolboxIDList": (props.existingProps.toolboxIDList?.length > 0) ? props.existingProps.toolboxIDList : [Number(initialToolBoxId?.packageMapPrimaryKey)],
                "startDate": props.existingProps.startDate !== "" ? props.existingProps.startDate : initialStartDate,
                "endDate": props.existingProps.endDate !== "" ? props.existingProps.endDate : initialEndDate,
                "dealerOperations":  dealerOperations?.length > 0 ? dealerOperations : (AUTO_DEFAULT_FILTER[activeProgram] || ['All'])
            }
            setQueryDto(data)
            dispatch(fetchDealerActionItemReport(onSuccess, onFailure, data))
        } catch (error) {
            console.error("Error fetching progress bar data:", error);
        }
    }

    useEffect(() => {
        const toolBoxReady = props.toolboxByType?.toolboxByType?.length > 0;
        const cycleReady = props.cycleDataList?.length > 0;

        if (toolBoxReady && cycleReady && !hasFetched) {
            fetchProgressBarData();
            setHasFetched(true);
        }
    }, [props.toolboxByType?.toolboxByType, props.cycleDataList, hasFetched]);

    return (
        <div className="actionItem">
            <div className={"widget-header-report  widget-header-" + props.theme.name} title={I18n.t('dashboardHeaders.ActionItemsInProgressElement')}>
                {I18n.t('Table.ActionItemReporFortNAS')}
                {selectedToDownload.length <= 0 ? <span style={{ float: 'right', fontSize: '1.2rem' }} ><Fa icon="download" className="mr-3" /></span>
                    : <span style={{ float: 'right', cursor: 'pointer', fontSize: '1.2rem' }} onClick={downloadPdf}><Fa icon="download" className="mr-3" /></span>
                }

            </div>
            <LoadingOverlay spinner text='Loading...'>
                <div className="actionItemTableNAS">
                    <div className="actionItemReport">
                        <BootstrapTable
                            keyField='actionPlanId'
                            data={data || []}
                            columns={columns}
                            selectRow={selectRow}
                            hover
                            condensed
                            rowEvents={rowEvents}
                            noDataIndication={I18n.t('evaluation.noRecords')}
                            style={{ backgroundColor: "#a1a" }}
                        />
                    </div>
                </div>

            </LoadingOverlay>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        user: state.loginReducer,
        actionItemReport: state.dashboardReducer.actionItemReport,
        activityToolBox: state.activityReducer,
        cycleDataList: state.dashboardReducer.cycleDataList,
        toolboxByType: state.leftNavReducer
    };
};
export default withRouter(connect(mapStateToProps)(withTheme(ActionItemReportNAS)));
